import { SectionProps } from "components/Section/section.props";
import { AppPlaceholder } from "@sitecore-content-sdk/nextjs";
import React, { JSX } from "react";
import {
  extractHiddenBlock,
  getBackgroundImageStyle,
  getBackgroundImageURL,
  normalizeStyles,
} from "../../utils";
import componentMap from ".sitecore/component-map";
import Image from "next/image";

export const Default = (props: SectionProps): JSX.Element => {
  console.log("---->[Section] Component");

  const { page, rendering, params } = props;

  const phKey = `section-${params?.DynamicPlaceholderId}`;
  const id = params?.RenderingIdentifier;
  const { isEditing, isPreview } = page.mode;
  const isNormalMode = !(isEditing || isPreview);

  const bgImgUrl = getBackgroundImageURL(params?.BackgroundImage, isEditing);
  const backgroundImageStyles =
    !isNormalMode && bgImgUrl ? getBackgroundImageStyle(bgImgUrl) : {};
  const styles = `${params?.Styles || ""}`.trimEnd();
  const paddingPageBuilder = isEditing ? "p-5" : "p-0";
  const hiddenBlockStyles = extractHiddenBlock(props?.params?.GridParameters);
  const componentStyles = normalizeStyles(
    `${paddingPageBuilder} ${styles} ${hiddenBlockStyles}`,
  );

  return (
    <section
      className={`section-component w-full relative ${componentStyles} ${bgImgUrl && isNormalMode ? "bg-transparent" : ""} ${bgImgUrl ? "section-with-image" : ""}`}
      id={id ?? undefined}
      style={backgroundImageStyles}
      data-testid="section-component"
      data-role="section-component"
    >
      {bgImgUrl && isNormalMode && (
        <Image
          src={bgImgUrl}
          alt=""
          sizes="100vw"
          className="absolute top-0 bottom-0 left-0 right-0 object-cover object-center z-[-1]"
          loading="lazy"
          fill
        />
      )}
      <AppPlaceholder
        name={phKey}
        rendering={rendering}
        page={page}
        componentMap={componentMap}
      />
    </section>
  );
};
